module.exports = __webpack_public_path__ + "static/media/icon-search.1048d65b.png";